import Vue from 'vue'
import Axios from 'axios'
import store from '@/store'
// import message from 'ant-design-vue/es/message'
// 签名生成
import { createSignature } from '@/utils/signatureCreate'
import { transformRequest, JsonToFormData } from '@/utils/util'
import { tipMsg } from '@/utils/tipTools'
import AES from '@/utils/aes'

function checkToken (errMsg = `${window.$globalHub.$t('noResponseData')}`, callback) {
  // 检查token是否过期
  // 检查token过期的地址
  const token = Vue.prototype.$token.loadToken().access_token
  const checkTokenUrl = `${Vue.prototype.$config.checkToken_url}?token=${token}`
  store.dispatch('checkToken', checkTokenUrl).then(res => {
    /** code
     * 4005 token不合法
     */
    if (res.data.code === 4005) {
      // 清空token
      Vue.prototype.$token.deleteToken()
      // 将登录状态设为未登录
      store.commit('updateLoginStatus', false)
      // 提示并回到token获取页重新获取token
      // alert(localStorage.getItem('lang'))
      //  国际化提示语句
      tipMsg('warning', `${window.$globalHub.$t('authorizationTip')}`)
      // alert('提示到期')
      setTimeout(() => {
        window.$globalHub.$router.push('/user/login')
      }, 500)
      // next({ path: '/user/login', query: { redirect: to.fullPath } })
    } else {
      // tipMsg('error', `${window.$globalHub.$t('authorizationTip')}`)
      tipMsg('warning', errMsg)
      if (callback) {
        callback()
      }
    }
  })
}

// 建立请求
const request = (method, url, data, options, type = 'console') => {
  // console.log(options)
  // 新加 type 判断接口]
  // console.log(type)
  const instance = Axios.create({
    baseURL: `${process.env.VUE_APP_REPORTURL}${type}/v1`,
    timeout: 10000
  })

  const config = Object.assign({}, {
    // 默认配置
    method,
    url
  }, options)

  // console.log(config)
  // console.log(instance.defaults.headers)
  // 时间戳固定一致（签名中和头部）
  const timestamp = new Date().getTime()
  let signature = ''
  if (method === 'post' || method === 'put') {
    config.data = data
    signature = createSignature(config.headers['Content-Type'], config.data, timestamp)
  } else {
    config.params = data
    signature = createSignature(config.headers['Content-Type'], config.params, timestamp)
  }

  // 获得签名，并加入头部
  instance.defaults.headers.common['signature'] = signature
  // 头部加入时间戳
  instance.defaults.headers.common['timestamp'] = timestamp
  // 头部加入 lang
  instance.defaults.headers.common['lang'] = store.getters.lang
  // 请求头放tenantNo
  const USERINFO = JSON.parse(store.getters.userInfo || '{}')
  instance.defaults.headers.common['tenantNo'] = USERINFO.tenantNo || ''
  // 请求头加入userName、userAlias
  instance.defaults.headers.common['userName'] = USERINFO.username || ''
  // instance.defaults.headers.common['userAlias'] = USERINFO.custAlias || ''
  // console.log('###################', store.getters.userInfo)
  instance.defaults.headers.common['userAlias'] = 'admin'
  // 请求头加 accesstoken
  const token = AES.Decrypt(Vue.prototype.$cookies.get('access_token')) || ''
  instance.defaults.headers.common['accesstoken'] = token || ''
  // 避免账户没有返回数据，先写死租户号
  // instance.defaults.headers.common['tenantNo'] = '02de2163789f43b8a665299b1a31f878' // 任务管理
  // instance.defaults.headers.common['tenantNo'] = 'a4c6d7bcce3f40559f422a8aa1712ac9' // 变量管理
  // instance.defaults.headers.common['tenantNo'] = '371b149c17c64eb6bf37f532aef7ba66' // 机器人管理
  // instance.defaults.headers.common['tenantNo'] = '3c7cb0f50ee34bb685b749e0f65266a7' // 任务数据
  // instance.defaults.headers.common['tenantNo'] = 'c01413b3cf5541278f676df26aebda43' // 报表

  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      return config
    },
    error => {
      checkToken()
      return Promise.reject(error)
    }
  )

  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      // 没有返回值
      if (!response.data) {
        checkToken()
        // return Promise.reject(response.data)
        return
      }
      const code = response.data.code
      // 下载接口，没有code
      if (code === undefined) {
        return Promise.resolve(response.data)
      }
      if (code === 0) {
        return Promise.resolve(response.data.result)
      } else {
        // 4009:调用凭证不合法 401:token无法识别 4005:AccessToken不合法或已在别处登录
        if (code === 4009 || code === 401) {
          const logOutUrl = {
            url: Vue.prototype.$config.logoutUri,
            access_token: Vue.prototype.$token.loadToken().access_token,
            callback: Vue.prototype.$config.localuri
          }
          store.dispatch('LogOut', logOutUrl)
          return
        }
        return Promise.reject(response.data)
      }
    },
    error => {
      if (error && error.response) {
        console.log(error.response)
        // console.log(process.env.BASE_URL, `${process.env.BASE_URL}public/404.html`)
        // window.location.replace(`${process.env.BASE_URL}public/404.html`)
        /**
         * 404：表示系统维护
         */
        // if (error.response.status === 404) {
        //   window.location.replace(`${process.env.BASE_URL}public/404.html`)
        // }
      }
      return Promise.reject(error)
    }
  )

  return new Promise((resolve, reject) => {
    instance(url, config).then(response => {
      resolve(response)
    }).catch(err => {
      checkToken(err.msg || `${window.$globalHub.$t('msg.outErr')}`, reject(err))
      // if (err.msg) {
      //   message.error(err.msg)
      // } else {
      //   message.error(`${window.$globalHub.$t('msg.outErr')}`)
      // }
    })
  })
}

// 导出
export default {
  get (url, data, config = {}, type) {
    if (JSON.stringify(config) === '{}') {
      config = {
        headers: {}
      }
    }
    return request('get', url, data, config, type)
  },
  post (url, data, config = {}) {
    config.headers = {
      'Content-Type': 'application/json; charset=UTF-8'
    }
    return request('post', url, data, config)
  },
  $post (url, data, config = {}) {
    config.headers = {
      'Content-Type': 'multipart/form-data; charset=UTF-8'
    }
    return request('post', url, transformRequest(data), config)
  },
  delete (url, data, config = {}) {
    config = {
      headers: {}
    }
    return request('delete', url, data, config)
  },
  put (url, data, config = {}, type) {
    config.headers = {
      'Content-Type': 'application/json; charset=UTF-8'
    }
    return request('put', url, data, config, type)
  },
  $put (url, data, config = {}) {
    config.headers = {
      'Content-Type': 'application/json; charset=UTF-8'
    }
    return request('put', url, JsonToFormData(data), config)
  }
}
